import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "o-grid"
}
const _hoisted_2 = {
  key: 1,
  class: "o-grid"
}
const _hoisted_3 = { class: "o-grid__cell o-grid__cell--12 o-grid__cell--9-480 o-grid__cell--8-768 o-grid__cell--7-1024 o-grid__cell--6-1200 o-grid__cell--offset-3-480" }
const _hoisted_4 = { class: "o-grid o-grid--no-y-gutter o-grid--align-flex-end" }
const _hoisted_5 = { class: "o-grid__cell o-grid__cell--12" }
const _hoisted_6 = { class: "o-grid o-grid--align-middle u-mar-t-2" }
const _hoisted_7 = { class: "o-grid o-grid--align-middle u-mar-t-1" }
const _hoisted_8 = { class: "o-grid__cell o-grid__cell--12 o-grid__cell--9-480 o-grid__cell--8-768 o-grid__cell--7-1024 o-grid__cell--6-1200 u-form-grid-nospace-y" }
const _hoisted_9 = { class: "c-form-control-checkbox gev19__contexthelp" }
const _hoisted_10 = {
  class: "c-form-control-checkbox__label",
  for: "buendelRabatt",
  style: {"max-width":"92%"}
}
const _hoisted_11 = { class: "c-form-control-checkbox__label-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Steps = _resolveComponent("Steps")!
  const _component_tarifauswahl = _resolveComponent("tarifauswahl")!
  const _component_leistungstabelle = _resolveComponent("leistungstabelle")!
  const _component_tarifoptionen = _resolveComponent("tarifoptionen")!
  const _component_validierungs_fehler = _resolveComponent("validierungs-fehler")!
  const _component_v_h_v_fahrrad_modul = _resolveComponent("v-h-v-fahrrad-modul")!
  const _component_v_h_v_elementar_zusatz = _resolveComponent("v-h-v-elementar-zusatz")!
  const _component_produktmodul = _resolveComponent("produktmodul")!
  const _component_hug_rabatt = _resolveComponent("hug-rabatt")!
  const _component_icon_sprite = _resolveComponent("icon-sprite")!
  const _component_maklerrabatt = _resolveComponent("maklerrabatt")!
  const _component_beitrag = _resolveComponent("beitrag")!
  const _component_email_oder_herunterladen = _resolveComponent("email-oder-herunterladen")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Steps, {
      items: _ctx.navItems,
      active: 1,
      onGotoPage: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('goto-page', $event)))
    }, null, 8, ["items"]),
    _createElementVNode("section", null, [
      _createVNode(_component_tarifauswahl, { tarifauswahlInformationen: _ctx.tarifauswahlInformationen }, null, 8, ["tarifauswahlInformationen"]),
      _createVNode(_component_leistungstabelle, {
        inhalt: _ctx.leistungen,
        versicherungssumme: _ctx.piniaStore.state.tarifinformationen.versicherungssumme,
        aktiveLinie: _ctx.aktiveLinie,
        link: _ctx.getTIB()
      }, null, 8, ["inhalt", "versicherungssumme", "aktiveLinie", "link"]),
      _createVNode(_component_tarifoptionen, { tarifoptionInformationen: _ctx.tarifoptionInformationen }, null, 8, ["tarifoptionInformationen"]),
      (_ctx.piniaStore.state.isMakler && _ctx.piniaStore.state.tarifinformationen.sfr === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[2] || (_cache[2] = [
            _createElementVNode("div", { class: "o-grid__cell o-grid__cell--12 o-grid__cell--9-480 o-grid__cell--8-768 o-grid__cell--7-1024 o-grid__cell--6-1200 o-grid__cell--offset-3 notice-box" }, [
              _createElementVNode("strong", null, "Hinweis:"),
              _createTextVNode(" Das SFR-Modell ist obligatorisch, wenn mehr als 1 Vorschaden und eine Schadenquote >60 % dem Antrag zu Grunde liegen ")
            ], -1)
          ])))
        : _createCommentVNode("", true),
      (_ctx.fehler.vorschaedenAnzahl)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_validierungs_fehler, {
                    "fehler-text": _ctx.fehler.vorschaedenAnzahl
                  }, null, 8, ["fehler-text"])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_v_h_v_fahrrad_modul),
      _createVNode(_component_produktmodul, {
        produktmodule: _ctx.produktmodule,
        "zeige-icons": true
      }, {
        vhvElementarHinweis: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.elementarHinweisText), 1)
        ]),
        vhvElementar: _withCtx(() => [
          _createVNode(_component_v_h_v_elementar_zusatz, {
            fehler: _ctx.fehler,
            ref: "elementarZusatzRef"
          }, null, 8, ["fehler"])
        ]),
        unbekannteZuersZoneHinweis: _withCtx(() => _cache[3] || (_cache[3] = [
          _createElementVNode("div", { class: "o-grid__cell o-grid__cell--9" }, [
            _createElementVNode("ul", { class: "c-list" }, [
              _createElementVNode("li", { class: "c-list__item c-list__item_warning" }, " Der Beitrag kann ggf. steigen, da keine ZÜRS-Zone ermittelt werden konnte. ")
            ])
          ], -1)
        ])),
        _: 1
      }, 8, ["produktmodule"]),
      _createElementVNode("div", _hoisted_6, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "o-grid__cell o-grid__cell--12 o-grid__cell--3-480 u-text-align-right--480 u-form-grid-nospace-y" }, [
          _createElementVNode("h2", { class: "u-form-heading unset-text-align" }, "Rabatt")
        ], -1)),
        _createVNode(_component_hug_rabatt)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "o-grid__cell o-grid__cell--12 o-grid__cell--3-480 u-text-align-right--480 u-form-grid-nospace-y" }, null, -1)),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.piniaStore.state.tarifinformationen.buendelRabatt) = $event)),
              id: "buendelRabatt",
              name: "buendelRabatt",
              class: "c-form-control-checkbox__input",
              type: "checkbox",
              value: true,
              "aria-label": "Ja, es gibt bereits eine GEV Wohngebäude-Versicherung für dieselbe Anschrift",
              "data-cy": "buendelRabatt",
              tabindex: "0"
            }, null, 512), [
              [_vModelCheckbox, _ctx.piniaStore.state.tarifinformationen.buendelRabatt]
            ]),
            _createElementVNode("label", _hoisted_10, [
              _createVNode(_component_icon_sprite, {
                "icon-name": "icon-check-mark",
                "css-klassen": "c-form-control-checkbox__icon",
                "ist-klein": true
              }),
              _createElementVNode("span", _hoisted_11, [
                _createTextVNode(_toDisplayString(_ctx.piniaStore.state.isMakler === true
                  ? "Der Versicherungsnehmer besitzt bereits eine GEV Wohngebäude-Versicherung für dieselbe Anschrift "
                  : "Ja, ich habe bereits eine GEV Wohngebäude-Versicherung für dieselbe Anschrift "), 1),
                _cache[5] || (_cache[5] = _createElementVNode("strong", null, "(25% Rabatt)", -1))
              ])
            ])
          ])
        ])
      ]),
      _createVNode(_component_maklerrabatt, { fehler: _ctx.fehler }, null, 8, ["fehler"]),
      _createVNode(_component_beitrag, { onNextPage: _ctx.nextPage }, null, 8, ["onNextPage"]),
      _createVNode(_component_email_oder_herunterladen, {
        produkt: "vhv2024",
        "tracking-zusatz": "vergleich",
        onValidierungErforderlich: _ctx.validiereVorHerunterladenOderEmail,
        vorschlagZugriff: _ctx.vorschlagZugriff
      }, null, 8, ["onValidierungErforderlich", "vorschlagZugriff"])
    ])
  ], 64))
}